/** 目標/計畫/每期保費暨配置比例/繳別變更 */
import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/ACH';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/** 取得條款說明 */
export function getAgreeTermsACH() {
    return get(`${url}/getAgreeTerms`);
};

/** 輸入bankCode=銀行代號 取得保單 */
export function postPolicyACH(bankCode) {
    return post(`${url}/policyOverView`, { bankCode });
};

/** 取得電子化授權狀態 */
export function getSearchACH(barCode) {
    return post(`${url}/search`, { barCode });
};

/** 取得上筆單據資訊 */
export function getContinueInfoACH() {
    return get(`${url}/continueInfo`, null, { ...options, closeAlert: true });
};

/** 針對網銀帳號密碼驗證/立碼驗取得可驗證銀行列表，輸入參數type：OnlineBank=網銀帳號密碼驗證、LinkPay=立碼驗 */
export function getBankListACH(type) {
    return get(`${url}/bankList`, { type });
};

/** 條款同意 */
export function postAgreeACH() {
    return post(`${url}/agree`);
};

/** 電子化授權 送出類型 */
export function submitTypeACH(data) {
    return post(`${url}/submitType`, { type: data }, { ...options, repeatRequestCancel: true });
};
/** 電子化授權 送出變更 */
export function submitACH(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
};

/** 電子化授權 送出此次申請保單內容 */
export function submitPolicyACH(data) {
    return post(`${url}/submitPolicy`, data);
};

/** 電子化授權 送出申請金融機構轉帳電子化繳費授權繼續授權下一張保單 */
export function submitContinueACH(regiNo) {
    return post(`${url}/submitContinue`, { regiNo }, { ...options, repeatRequestCancel: true });
};

/** 電子化授權 送出此次申請銀行內容 */
export function submitBankACH(data) {
    return post(`${url}/submitBank`, data, { ...options, errorDialog: false, repeatRequestCancel: true });
};
